import { render } from "./Unit1-1.vue?vue&type=template&id=d1fa0752&scoped=true"
import script from "./Unit1-1.vue?vue&type=script&lang=js"
export * from "./Unit1-1.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Unit1-1.css?vue&type=style&index=1&id=d1fa0752&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1fa0752"]])

export default __exports__